var exports = {
  "ln": "xe533113f--212dfe--time-label",
  "V8": "xe533113f--212dfe--relative",
  "ys": "xe533113f--212dfe--absolute",
};

module.exports = exports;
